export default __webpack_public_path__ + "a7a48503ae40176956a3434b2654585b.png";